/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  landingPage: [],
}

const RouteUrl = {
  GetAllData: 'landingPage',
  GetData: '',
  EditData: 'landingPage/',
  DeleteData: 'landingPage',
  CreateData: 'landingPage',
}
const thunkName = {
  getToatal: 'landingPage-total',
  GetAllData: 'landingPage-GetALLDATA',
  GetData: '',
  EditData: '',
  DeleteData: 'landingPage-Delete',
  CreateData: 'landingPage-Create',
}

export const GetAllData: any = createAsyncThunk(thunkName.GetAllData, async (data, thunkApi) => {
  const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())
  return response.data
})

export const DeleteData: any = createAsyncThunk(
  thunkName.DeleteData,
  async (data: any, thunkApi) => {
    const response = await axios.delete(`${API_URL}${RouteUrl.DeleteData}/${data?.id}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }

    thunkApi.dispatch(GetAllData())
  }
)

export const CreateData: any = createAsyncThunk(
  thunkName.CreateData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}${RouteUrl.CreateData}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
  }
)
export const UpdateData: any = createAsyncThunk(thunkName.EditData, async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.put(`${API_URL}${RouteUrl.CreateData}/${data?.id}`, data.data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }
  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetAllData())
})
const LandingPage = createSlice({
  name: 'LandingPage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, landingPage: action?.payload}
    })
  },
})

export default LandingPage.reducer
